import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { sendRequest, serviceList } from 'src/utils';

const useHookNoti = () => {
    const [listNotification, setListNotification] = useState([]);
    const readNotifyRef = useRef(false);
    const [totalUnReadNotify, setTotalUnReadNotify] = useState(0);
    const getNotiStopRef = useRef(false);
    const [totalNotification, setTotalNotification] = useState(0);
    const getNotificationRef = useRef(false);
    const [loading, setLoading] = useState(false);
    const lastIDNotification = useRef(0);
    const [needGetDataNotificationNext, setNeedGetDataNotificationNext] = useState(false);
    const [getFlagsNotification, setGetFlagsNotification] = useState(false);

    const handleScrollToBottom = useCallback(() => {
        if (!loading && !needGetDataNotificationNext) {
            setLoading(true);
            setNeedGetDataNotificationNext(true);
        }
    }, [loading, needGetDataNotificationNext]);

    useEffect(() => {
        if (needGetDataNotificationNext && lastIDNotification.current) {
            getDataNotificationNext();
            setNeedGetDataNotificationNext(false);
            setLoading(false);
        }
    }, [needGetDataNotificationNext]);

    const getDataNotification = useCallback(() => {
        if (getNotificationRef.current || getNotiStopRef.current || getFlagsNotification) {
            return;
        }
        getNotificationRef.current = true;
        setGetFlagsNotification(true);
        const Inval = [9999999999999999999];
        sendRequest(
            serviceList.getListNotification,
            Inval,
            getDataNotificationResult,
            true,
            timeOutFunctGetNotification,
            40000
        );
    }, []);

    const getDataNotificationResult = (reqInfoMap, message) => {
        getNotificationRef.current = false;
        setGetFlagsNotification(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const newNotti = (message.proc_data.rows[0]?.o_1 || []).filter((row) => row.device_nm);
            console.log(newNotti);
            if (newNotti.at(-1)?.notify_id !== lastIDNotification.current) {
                console.log('console.log(newNotti): ', newNotti);
                setListNotification(newNotti);
                setTotalUnReadNotify(message.proc_data.total_not_read);
                setTotalNotification(message.proc_data.total_not_read + message.proc_data.total_read);

                lastIDNotification.current = message.proc_data.rows[0].o_1.at(-1)?.notify_id;
                getNotiStopRef.current = false;
            } else {
                getNotiStopRef.current = true;
            }
        }
    };

    const getDataNotificationNext = useCallback(() => {
        if (getNotificationRef.current || getNotiStopRef.current || getFlagsNotification) {
            return;
        }
        getNotificationRef.current = true;
        setGetFlagsNotification(true);
        const Inval = [lastIDNotification.current];
        sendRequest(
            serviceList.getListNotification,
            Inval,
            getDataNotificationNextResult,
            true,
            timeOutFunctGetNotification,
            40000
        );
    }, [lastIDNotification.current]);

    const getDataNotificationNextResult = (reqInfoMap, message) => {
        getNotificationRef.current = false;
        setGetFlagsNotification(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const newNotti = (message.proc_data.rows[0]?.o_1 || []).filter((row) => row.device_nm);
            if (newNotti.at(-1)?.notify_id !== lastIDNotification.current) {
                setListNotification((prev) => [...prev, ...newNotti]);
                setTotalUnReadNotify(message.proc_data.total_not_read);
                setTotalNotification(message.proc_data.total_not_read + message.proc_data.total_read);

                if (message.proc_data.rows[0].o_1?.length > 0) {
                    lastIDNotification.current = message.proc_data.rows[0].o_1.at(-1)?.notify_id;
                    getNotiStopRef.current = false;
                } else {
                    getNotiStopRef.current = true;
                }
            } else {
                getNotiStopRef.current = true;
            }
        }
    };

    const timeOutFunctGetNotification = (reqInfo) => {
        getNotificationRef.current = false;
        setGetFlagsNotification(false);
        toast.error(t('error.time_out'));
        // console.log("timeOut Notification");
    };

    return {
        handleScrollToBottomNotification: handleScrollToBottom,
        loadingNotification: loading,
        setLoadingNotification: setLoading,
        lastIDNotification,
        needGetDataNotificationNext,
        setNeedGetDataNotificationNext,
        getFlagsNotification,
        setGetFlagsNotification,
        getDataNotification,
        getNotificationRef,
        listNotification,
        setListNotification,
        readNotifyRef,
        totalUnReadNotify,
        setTotalUnReadNotify,
        getNotiStopRef,
        totalNotification,
        setTotalNotification,
    };
};

export default useHookNoti;
